import { comparator } from '@forgerock/backstage-ui-core';

export function multiComparator<T>(options: [ fieldName: keyof T, ascending: boolean ][]) {
  return (a, b) => {
    for (const [ fieldName, ascending ] of options) {
      const result = comparator(fieldName, ascending)(a, b);
      if (result !== 0) {
        return result;
      }
    }
    return 0;
  };
}
